module.exports = __webpack_public_path__ + "img/commission-warning.4016f541.svg";